import { render, staticRenderFns } from "./NewPackingList.vue?vue&type=template&id=157d11e6"
import script from "./NewPackingList.vue?vue&type=script&lang=js"
export * from "./NewPackingList.vue?vue&type=script&lang=js"
import style0 from "./NewPackingList.vue?vue&type=style&index=0&id=157d11e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports